import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Heart } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_c2c-nonprofit/artifacts/0drtr76p_c2c.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0033A0] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="C2C Logo"
                className="h-16 w-16 object-contain"
              />
              <div>
                <h3 className="font-bold text-xl text-white">Confidence2Create</h3>
                <span className="text-[#FFC107] text-sm font-semibold">Inc.</span>
              </div>
            </div>
            <p className="text-white/80 leading-relaxed">
              Educating and closing the gap between the young and the older, helping to bring unity back into our communities.
            </p>
            <p className="text-[#FFC107] font-bold text-lg italic">#Everybody eats</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-[#FFC107]">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Testimonials", path: "/testimonials" },
                { name: "Gallery", path: "/gallery" },
                { name: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/80 hover:text-[#FFC107] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-[#FFC107]">Our Programs</h4>
            <ul className="space-y-3 text-white/80">
              <li>C2C Culinary</li>
              <li>Construction Training</li>
              <li>Landscaping Skills</li>
              <li>Youth Leadership</li>
              <li>Meals on Wheels</li>
              <li>Culinary Buddies</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-[#FFC107]">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-[#FFC107] flex-shrink-0 mt-1" />
                <a
                  href="tel:651-703-4734"
                  data-testid="footer-phone"
                  className="text-white/80 hover:text-[#FFC107] transition-colors"
                >
                  651-703-4734
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={20} className="text-[#FFC107] flex-shrink-0 mt-1" />
                <a
                  href="mailto:confidencetocreate@gmail.com"
                  data-testid="footer-email"
                  className="text-white/80 hover:text-[#FFC107] transition-colors break-all"
                >
                  confidencetocreate@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#FFC107] flex-shrink-0 mt-1" />
                <span className="text-white/80">
                  670 W Wheelock Parkway, Suite 6<br />
                  Saint Paul, MN 55117
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Facebook size={20} className="text-[#FFC107] flex-shrink-0 mt-1" />
                <a
                  href="https://www.facebook.com/Confidence2CreateInc"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-facebook"
                  className="text-white/80 hover:text-[#FFC107] transition-colors"
                >
                  @Confidence2CreateInc
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 md:mt-12 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Confidence 2 Create Inc. All rights reserved.
          </p>
          <Link
            to="/donations"
            data-testid="footer-donate-btn"
            className="btn-secondary flex items-center gap-2"
          >
            <Heart size={18} />
            Support Our Mission
          </Link>
        </div>

        {/* Biblical Reference */}
        <div className="text-center mt-8">
          <p className="text-white/50 text-sm italic">
            "If you pour yourself out for the hungry and satisfy the desire of the afflicted, then shall your light rise in the darkness" — Isaiah 58:10
          </p>
        </div>
      </div>
    </footer>
  );
}
